export const installUrl =
  '/auth/slack/install/callback&scope=users%3Aread%2Cusers.profile%3Aread%2Cchat%3Awrite%2Ccommands%2Cim%3Ahistory%2Clinks%3Aread%2Clinks%3Awrite';

export const slackInstallHref = `https://slack.com/oauth/v2/authorize?redirect_uri=${import.meta.env.VITE_SERVER_URL}${installUrl}&state=slack_button&client_id=${import.meta.env.VITE_SLACK_CLIENT_ID}`;

export const loginHref = `https://slack.com/openid/connect/authorize?scope=openid,email,profile&response_type=code&redirect_uri=${import.meta.env.VITE_SERVER_URL}/auth/slack/callback&client_id=${import.meta.env.VITE_SLACK_CLIENT_ID}&state=slack_button`;
